import React from 'react'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import Typography from '@material-ui/core/Typography'
import cn from 'classnames'
import { checkValidForPlusLoadQuantity } from '../utils/check-valid-for-plus-load-quantity'

interface Props {
  classes: any,
  onChange(e: React.ChangeEvent<HTMLInputElement>): void,
  value: number | undefined,
}

const PlusLoadQuantityInput = (props: Props) => {
  const {
    classes,
    onChange,
    value,
  } = props
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value: string = e.target.value
    if (checkValidForPlusLoadQuantity(value)) {
      onChange(e)
    }
  }
  return (
    <Input
      autoFocus
      id='plus-load-quantity-input'
      type={'number'}
      value={value === undefined ? '' : value}
      onChange={handleInputChange}
      className={cn(classes.largeInput)}
      inputProps={{
        step: '0.1',
      }}
      placeholder='0.0'
      endAdornment={
        <InputAdornment position='end' className={cn(classes.largeLabel)}>
          <Typography className={cn(classes.largeLabel)}>m³</Typography>
        </InputAdornment>
      }
    />
  )
}

export default PlusLoadQuantityInput
